module.exports = __webpack_public_path__ + "static/media/Placaj ceramic Klinker Bangalore.0aa95b29.jpg";